import { ICompetitionRanking } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const TeamRankingWrapper = React.lazy(() => import('./team-ranking'));
export interface IDynamicCompetitionRanking extends IComponentModel<ICompetitionRanking> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicCompetitionRanking = ({
  /* istanbul ignore next: default value */ model = {} as ICompetitionRanking,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicCompetitionRanking) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <TeamRankingWrapper
      live={live}
      initialModel={validateModel(model) as ICompetitionRanking}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicCompetitionRanking;
